module.exports = __webpack_public_path__ + "static/media/hdi-phone.1be9e659.svg";